export default "__VITE_ASSET__ChhsR8Ls__"